import { createFileRoute } from "@tanstack/react-router";
import { ImagesContainer } from "@/features/images";

export const Route = createFileRoute("/$store/_layout/images")({
	component: ImagesPage,
});

function ImagesPage() {
	return <ImagesContainer />;
}
